import React, { FC } from "react";
import { observer } from 'mobx-react-lite';
import { Instruction, InstructionCategory } from "../../../../../machinelogic/types";
import { MotorNodeFactory } from './motor_instruction_nodes';
import { ConditionNode } from './ConditionNode';
import { FsmNode } from './FsmNode';
import { LogNode } from './LogNode';
import { LoopNode } from './LoopNode';
import { OutputNode } from './OutputNode';
import { SetVariableNode } from './SetVariableNode';
import { TriggerNode } from './TriggerNode';
import { WaitNode } from './WaitNode';
import { RobotLoopNodeSimple } from "./RobotLoopNodeSimple";
import { RobotNodeSimple } from "./RobotNodeSimple";

export interface InstructionNodeProps {
  instruction: Instruction;
  titleClassName?: string;
  isSelected: boolean;
  isInvalid: boolean;
  onClick: () => void;
}

export const InstructionNodeFactory: FC<InstructionNodeProps> = observer((props) => {
  switch (props.instruction.category) {
    case InstructionCategory.MOTOR: return <MotorNodeFactory {...props} instruction={props.instruction} />;
    case InstructionCategory.CONDITION: return <ConditionNode {...props} instruction={props.instruction} />;
    case InstructionCategory.FSM: return <FsmNode {...props} instruction={props.instruction} />;
    case InstructionCategory.LOG: return <LogNode {...props} instruction={props.instruction} />;
    case InstructionCategory.LOOP: return <LoopNode {...props} instruction={props.instruction} />;
    case InstructionCategory.OUTPUT: return <OutputNode {...props} instruction={props.instruction} />;
    case InstructionCategory.SET_VARIABLE: return <SetVariableNode {...props} instruction={props.instruction} />;
    case InstructionCategory.TRIGGER: return <TriggerNode {...props} instruction={props.instruction} />;
    case InstructionCategory.WAIT_FOR: return <WaitNode {...props} instruction={props.instruction} />;
    case InstructionCategory.ROBOT: return <RobotNodeSimple {...props} instruction={props.instruction} />;
    case InstructionCategory.ROBOT_LOOP: return <RobotLoopNodeSimple {...props} instruction={props.instruction} />;
  }
});
